<template>
  <BaseForm
    v-if="organisation"
    ref="baseForm"
    :title="'Organisation'"
    :data-object="transformedOrganisation"
    :content-type="'organisation'"
    :completed-location="completedLocation"
  >
    <template #content>
      <v-text-field
        v-model.trim="organisation.name"
        label="Name"
        :disabled="loading"
        :loading="loading"
        placeholder="Name"
        icon="account"
      />

      <AvatarUploadForm ref="uploadForm" :current-avatar="originalAvatar" />
    </template>
  </BaseForm>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, Ref, ref } from 'vue'

import { apiClient } from '@/api/ApiClient'
import AvatarUploadForm from '@/components/common/AvatarUploadForm.vue'
import BaseForm from '@/components/common/BaseForm.vue'
import { Organisation } from '@/models/core/organisation'

const props = defineProps({
  id: {
    required: true,
    type: String,
  },
})

const uploadForm: Ref<typeof AvatarUploadForm> = ref(null)
const baseForm: Ref<typeof BaseForm> = ref(null)
let organisation: Ref<Organisation> = ref(null)
let loading: Ref<boolean> = ref(false)
let originalName: Ref<string> = ref(null)
let originalAvatar: Ref<string> = ref(null)

onBeforeMount(async () => {
  loading.value = true
  try {
    const response = await apiClient.get('organisation', props.id)
    originalName.value = response.name
    originalAvatar.value = response.avatar
    organisation.value = response
    loading.value = false
  } catch (error) {
    console.log({ error })
  }
})

const transformedOrganisation = computed(() => {
  if (uploadForm.value?.avatar) {
    organisation.value.avatar = uploadForm.value.avatar
  }
  return organisation
})

const completedLocation = computed(() => {
  if (organisation.value?.name !== originalName.value && props.id !== '0') {
    // TODO: This is not optimal. Best case would be to fetch new organisation slug here
    return {
      name: 'overview',
      replace: true,
    }
  } else {
    return null
  }
})
</script>
